import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '',
    component: () => import('../layout/index.vue'),
    children: [
      { path: '', redirect: 'customers',meta: { title: '客户管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'customers', name: 'CustomerManagement', component: () => import('../views/customers/index.vue'),meta: { title: '客户管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'opportunities', name: 'OpportunityManagement', component: () => import('../views/opportunities/index.vue'),meta: { title: '机会点管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'contracts', name: 'ContractManagement', component: () => import('../views/contracts/index.vue'),meta: { title: '合同管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'invoices', name: 'InvoiceManagement', component: () => import('../views/invoices/index.vue'),meta: { title: '开票管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'payments', name: 'PaymentManagement', component: () => import('../views/payments/index.vue'),meta: { title: '回款管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'employees', name: 'EmployeeManagement', component: () => import('../views/employees/index.vue'),meta: { title: '员工管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'quotations', name: 'QuotationManagement', component: () => import('../views/quotations/index.vue'),meta: { title: '报价单管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'projects', name: 'ProjectManagement', component: () => import('../views/projects/index.vue'),meta: { title: '项目交付管理', roles: ['管理员', '销售', '开发', '运维'] } },
      { path: 'expenditure', name: 'ExpenditureManagement', component: () => import('../views/expenditure/index.vue'),meta: { title: '第三方项目支出管理', roles: ['管理员', '销售', '开发', '运维'] } }
    ]
  },
  // 404 页面
  { path: '*', redirect: '/404', component: () => import('../views/404.vue'), meta: { hidden: true } }
]

const router = new VueRouter({
  routes
})


// ---------------- 关键：添加全局路由守卫 ----------------
router.beforeEach((to, from, next) => {
  // 1. 获取本地存储的 token（登录成功后存储）
  const token = localStorage.getItem('token');

  // 2. 定义白名单：无需登录即可访问的路由（如登录页）
  const whiteList = ['/login'];

  // 3. 未登录（无 token）
  if (!token) {
    // 如果访问的是白名单路由（如登录页），允许访问
    if (whiteList.includes(to.path)) {
      next();
    } else {
      // 非白名单路由，强制跳转到登录页
      next('/login');
    }
  }
  // 4. 已登录（有 token）
  else {
    // 如果访问的是登录页，重定向到首页（避免重复登录）
    if (to.path === '/login') {
      next('/customers');  // 跳转到主页面
    } else {
      const userRole = localStorage.getItem('userRole') || '管理员'; // 默认admin，方便测试

      // 判断路由是否有 roles 限制
      if (to.meta && to.meta.roles) {
        if (to.meta.roles.includes(userRole) || to.meta.roles.includes('any')) {
          next();
        }else {
          // 无权限访问，重定向到 403 页面或其他提示页面
          next('/403'); // 假设有 403 页面
        }
      }else {
        next();
      }
    }
  }
});

export default router 